export default "__VITE_ASSET__OUcv7Tfl__"